<div
	*ngrxLet="package$ | async as package"
	[editableInStoryblok]="_editable"
	[ngClass]="{ 'h-full': !stopGrow() }"
	class="w-full"
>
	@if (package) {
		<vp-persuade-card
			[cardUrl]="button()[0].link.cached_url"
			[content]="package?.bulletContent"
			[ctaText]="button()[0].text"
			[ctaUrl]="button()[0].link.cached_url"
			[images]="package?.images || []"
			[overline]="'global.package-label' | translate"
			[price]="package?.price || { amount: 0 }"
			[pricingToolTip]="{
				occupancy: pricingTooltipOccupancy,
			}"
			[title]="package?.name ?? ''"
			[useVerticalCard]="useVertical()"
			imageVariant="mini-carousel"
		/>
	}
</div>
